/*
 * @see [Documentation](https://nuxt-graphql-middleware.dulnan.net/advanced/templates#helpers)
 */
export const serverApiPrefix = '/nuxt-api/graphql'
export function getEndpoint(operation, operationName) {
  return serverApiPrefix + '/' + operation + '/' + operationName
}